"use strict";
// Dual architecture types that can be shared between packages
// These types support both legacy and kit architectures
Object.defineProperty(exports, "__esModule", { value: true });
